(function () {
  'use strict';

  const CONFIG = {
    enableDebug: window.sas_enable_debug || false,
    saleBadgeSelector: '.sas-discount-badge',
    // Selectors for product cards (collection/search pages)
    cardSelector: '.card-wrapper',
    cardBadgeContainer: '.card__badge',
    // Selectors for product page
    productPriceSelector: '.product__info-container .price',
    productMediaSelector: '.product__media-wrapper',
    oldPriceSelector: 's.price-item--regular',
    newPriceSelector: '.price-item--sale',
    badgeClass: 'badge sas-discount-badge',
    badgePosition: 'top right',
    colorScheme: window.sas_discount_badge_color_scheme,
    label: window.sas_discount_badge_label,
  };

  // Utilities
  const Utils = {
    log(...args) {
      if (CONFIG.enableDebug) {
        console.log('[SAS Discount Badge]', ...args);
      }
    },
    error(...args) {
      console.error('[SAS Discount Badge]', ...args);
    },
    formatDiscount(percent) {
      return `-${percent}%`;
    },
    getBadgePositionClass(position) {
      const posMap = {
        'top left': '',
        'top right': 'top right',
        'bottom left': '',
        'bottom right': 'right',
      };
      return posMap[position] || '';
    },
  };

  function addSaleBadgeToCards() {
    document.querySelectorAll(CONFIG.cardSelector).forEach((card) => {
      try {
        const oldPriceEl = card.querySelector(CONFIG.oldPriceSelector);
        const newPriceEl = card.querySelector(CONFIG.newPriceSelector);

        if (!oldPriceEl || !newPriceEl) {
          Utils.log('Skipping card - missing price', card);
          return;
        }

        const old = Number(oldPriceEl.textContent.replace(/[^\d.]/g, ''));
        const current = Number(newPriceEl.textContent.replace(/[^\d.]/g, ''));

        if (isNaN(old) || isNaN(current) || old <= current) {
          Utils.log('Skipping card - invalid values or not discounted', { old, current, card });
          return;
        }

        // Check if discount badge already exists
        if (card.querySelector(CONFIG.saleBadgeSelector)) {
          Utils.log('Discount badge already present, skipping', card);
          return;
        }

        const discount = Math.round(((old - current) / old) * 100);

        // Create badge using theme's default styling
        const badge = document.createElement('span');
        const positionClass = Utils.getBadgePositionClass(CONFIG.badgePosition);
        badge.className = `${CONFIG.badgeClass} color-${CONFIG.colorScheme} ${positionClass}`.trim();
        badge.textContent = Utils.formatDiscount(discount) + ' ' + CONFIG.label;

        // Add badge directly to card wrapper (top right position via CSS)
        card.appendChild(badge);

        Utils.log('Added discount badge:', badge.textContent, card);
      } catch (e) {
        Utils.error('Error processing card:', e, card);
      }
    });
  }

  function addSaleBadgeToProductPage(forceUpdate = false) {
    const priceContainer = document.querySelector(CONFIG.productPriceSelector);

    if (!priceContainer) {
      Utils.log('Product page price container not found, skipping');
      return;
    }

    try {
      const mediaWrapper = document.querySelector(CONFIG.productMediaSelector);
      if (!mediaWrapper) {
        Utils.log('Product media wrapper not found');
        return;
      }

      const existingBadge = mediaWrapper.querySelector(CONFIG.saleBadgeSelector);
      if (existingBadge) {
        if (forceUpdate) {
          existingBadge.remove();
          Utils.log('Removed existing badge for update');
        } else {
          Utils.log('Discount badge already present on product page, skipping');
          return;
        }
      }

      const oldPriceEl = priceContainer.querySelector(CONFIG.oldPriceSelector);
      const newPriceEl = priceContainer.querySelector(CONFIG.newPriceSelector);

      if (!oldPriceEl || !newPriceEl) {
        Utils.log('Product page - missing price elements (variant may not have discount)');
        return;
      }

      const old = Number(oldPriceEl.textContent.replace(/[^\d.]/g, ''));
      const current = Number(newPriceEl.textContent.replace(/[^\d.]/g, ''));

      if (isNaN(old) || isNaN(current) || old <= current) {
        Utils.log('Product page - no discount for this variant', { old, current });
        return;
      }

      const discount = Math.round(((old - current) / old) * 100);

      const badge = document.createElement('span');
      const positionClass = Utils.getBadgePositionClass(CONFIG.badgePosition);
      badge.className =
        `${CONFIG.badgeClass} color-${CONFIG.colorScheme} ${positionClass} sas-discount-badge--product-page`.trim();
      badge.textContent = Utils.formatDiscount(discount) + ' ' + CONFIG.label;

      // Add badge to product media (top right of main image)
      mediaWrapper.appendChild(badge);
      Utils.log('Added discount badge to product page:', badge.textContent);
    } catch (e) {
      Utils.error('Error processing product page:', e);
    }
  }

  function setupPriceChangeListener() {
    const priceContainer = document.querySelector(CONFIG.productPriceSelector);

    if (!priceContainer) {
      Utils.log('Price container not found for listener');
      return;
    }

    Utils.log('Setting up price change listener');

    document.addEventListener('variant:change', () => {
      Utils.log('Variant change event received');
      addSaleBadgeToProductPage(true);
    });

    Utils.log('Price change listener set up successfully');
  }

  function initSaleBadgeLogic() {
    Utils.log('Initializing Discount Badge logic');
    addSaleBadgeToCards();
    addSaleBadgeToProductPage();
    setupPriceChangeListener();
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSaleBadgeLogic);
    } else {
      initSaleBadgeLogic();
    }
  } catch (err) {
    Utils.error('Unexpected error:', err);
  }
})();
